<template>
  <svg
    id="multi-branches-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="200"
    height="163"
    viewBox="0 0 308.973 252.07"
  >
    <g
      id="Group_1838"
      data-name="Group 1838"
      transform="translate(-153.739 -479.486)"
    >
      <g
        id="Group_1307"
        data-name="Group 1307"
        transform="translate(216.121 479.486)"
      >
        <g
          id="Group_1306"
          data-name="Group 1306"
          transform="translate(7.729)"
        >
          <path
            id="Path_286"
            data-name="Path 286"
            class="cls-1"
            d="M45.133 23.75a40.974 40.974 0 0 0 2.667-5.172 41.932 41.932 0 0 0 1.918-5.5 42.658 42.658 0 0 0 1.148-5.741 43.093 43.093 0 0 0 .355-5.894l-11.6-.091q0 .891-.06 1.778T39.4 4.9q-.106.881-.263 1.754t-.364 1.735l-.015-.018-.014-.019-.014-.019-.015-.018A22.593 22.593 0 0 0 35.3 4.9a21.655 21.655 0 0 0-3.97-2.544 20.932 20.932 0 0 0-4.39-1.6 20.539 20.539 0 0 0-4.664-.57h-.524L21.49.2l-.261.01A20.805 20.805 0 0 0 12.7 2.435a22.325 22.325 0 0 0-6.857 5.408 24.119 24.119 0 0 0-4.465 7.8 25.159 25.159 0 0 0-1.352 9.378A24.894 24.894 0 0 0 2.2 34.2a23.5 23.5 0 0 0 5.133 7.278 21.73 21.73 0 0 0 7.3 4.639 20.658 20.658 0 0 0 13.09.527 21.2 21.2 0 0 0 4.131-1.688 21.976 21.976 0 0 0 3.73-2.531 22.9 22.9 0 0 0 3.216-3.302q.211.864.368 1.741t.26 1.762q.1.885.152 1.778t.043 1.788l11.577-.161a43.182 43.182 0 0 0-.354-5.893 42.642 42.642 0 0 0-1.141-5.738 41.825 41.825 0 0 0-1.913-5.492 40.8 40.8 0 0 0-2.659-5.158zM29.2 32.473a10.516 10.516 0 0 1-3.684 2.24 10.049 10.049 0 0 1-8.018-.6 10.729 10.729 0 0 1-3.358-2.783 11.409 11.409 0 0 1-1.028-1.511 11.762 11.762 0 0 1-.781-1.661 12.044 12.044 0 0 1-.52-1.776 12.227 12.227 0 0 1-.245-1.856l-.01-.168-.007-.168v-.335a12.233 12.233 0 0 1 .446-3.282 11.9 11.9 0 0 1 1.27-2.955 11.311 11.311 0 0 1 1.989-2.454 10.643 10.643 0 0 1 2.6-1.783l.1-.05.1-.048.105-.046.107-.046a9.98 9.98 0 0 1 8.172.09 10.65 10.65 0 0 1 3.375 2.453 11.477 11.477 0 0 1 2.317 3.78q.191.51.336 1.035t.242 1.063q.1.537.146 1.083t.049 1.1q0 .35-.02.7t-.061.7q-.041.347-.1.69t-.141.683l-.111.115.068.073a12.05 12.05 0 0 1-.526 1.622 11.8 11.8 0 0 1-.741 1.512 11.5 11.5 0 0 1-.942 1.378 11.16 11.16 0 0 1-1.13 1.22z"
            transform="translate(62.833 59.592)"
          />
          <g
            id="Group_1153"
            data-name="Group 1153"
          >
            <g
              id="Group_1152"
              data-name="Group 1152"
            >
              <path
                id="Path_658"
                data-name="Path 658"
                class="cls-2"
                d="M316.157 271.529c-16.8-23.105-41.225-33.877-66.709-33.876 0 0-62.416 0-80.9 55.874-6.812 20.592-5.3 42.954 2.962 63.007a115.556 115.556 0 0 0 11.661 21.684c16.115 23.278 66.276 86.845 66.276 86.845h10.9c14-19.444 49.248-84.041 59.8-104.752 13.264-26.005 15.302-62.248-3.99-88.782zm-56.3 103.359a53.315 53.315 0 1 1 53.314-53.316 53.316 53.316 0 0 1-53.314 53.316z"
                transform="translate(-164.252 -237.653)"
              />
              <path
                id="Path_659"
                data-name="Path 659"
                class="cls-3"
                d="M316.157 271.529c-16.8-23.105-41.225-33.877-66.709-33.876 0 0-62.416 0-80.9 55.874-6.812 20.592-5.3 42.954 2.962 63.007a115.556 115.556 0 0 0 11.661 21.684c16.115 23.278 66.276 86.845 66.276 86.845h10.9c14-19.444 49.248-84.041 59.8-104.752 13.264-26.005 15.302-62.248-3.99-88.782zm-56.3 103.359a53.315 53.315 0 1 1 53.314-53.316 53.316 53.316 0 0 1-53.314 53.316z"
                transform="translate(-164.252 -237.653)"
              />
              <path
                id="Path_660"
                data-name="Path 660"
                class="cls-2"
                d="M330.629 272.1c-16.8-23.105-41.225-33.877-66.71-33.876 0 0-62.416 0-80.9 55.874-6.812 20.593-5.3 42.955 2.962 63.007a115.542 115.542 0 0 0 11.66 21.684c16.115 23.278 66.276 86.846 66.276 86.846s57.952-79.727 70.708-104.752c13.257-26.001 15.295-62.243-3.996-88.783zm-67.2 103.359a53.315 53.315 0 1 1 53.314-53.315 52.921 52.921 0 0 1-53.317 53.32z"
                transform="translate(-167.748 -237.792)"
              />
            </g>
            <path
              id="Path_661"
              data-name="Path 661"
              class="cls-2"
              d="M274.3 278.005a53.329 53.329 0 0 0-50.255 35.5 45.689 45.689 0 1 1 5.577 46.89 53.311 53.311 0 1 0 44.678-82.39z"
              transform="translate(-178.695 -247.4)"
            />
            <path
              id="Path_662"
              data-name="Path 662"
              class="cls-3"
              d="M274.3 278.005a53.329 53.329 0 0 0-50.255 35.5 45.689 45.689 0 1 1 5.577 46.89 53.311 53.311 0 1 0 44.678-82.39z"
              transform="translate(-178.695 -247.4)"
            />
          </g>
          <g
            id="Group_1230"
            data-name="Group 1230"
          >
            <g
              id="Group_1229"
              data-name="Group 1229"
            >
              <path
                id="Path_699"
                data-name="Path 699"
                class="cls-2"
                d="M316.157 271.529c-16.8-23.105-41.225-33.877-66.709-33.876 0 0-62.416 0-80.9 55.874-6.812 20.592-5.3 42.954 2.962 63.007a115.556 115.556 0 0 0 11.661 21.684c16.115 23.278 66.276 86.845 66.276 86.845h10.9c14-19.444 49.248-84.041 59.8-104.752 13.264-26.005 15.302-62.248-3.99-88.782zm-56.3 103.359a53.315 53.315 0 1 1 53.314-53.316 53.316 53.316 0 0 1-53.314 53.316z"
                transform="translate(-164.252 -237.653)"
              />
              <path
                id="Path_700"
                data-name="Path 700"
                class="cls-4"
                d="M316.157 271.529c-16.8-23.105-41.225-33.877-66.709-33.876 0 0-62.416 0-80.9 55.874-6.812 20.592-5.3 42.954 2.962 63.007a115.556 115.556 0 0 0 11.661 21.684c16.115 23.278 66.276 86.845 66.276 86.845h10.9c14-19.444 49.248-84.041 59.8-104.752 13.264-26.005 15.302-62.248-3.99-88.782zm-56.3 103.359a53.315 53.315 0 1 1 53.314-53.316 53.316 53.316 0 0 1-53.314 53.316z"
                transform="translate(-164.252 -237.653)"
              />
              <path
                id="Path_701"
                data-name="Path 701"
                class="cls-1"
                d="M330.629 272.1c-16.8-23.105-41.225-33.877-66.71-33.876 0 0-62.416 0-80.9 55.874-6.812 20.593-5.3 42.955 2.962 63.007a115.542 115.542 0 0 0 11.66 21.684c16.115 23.278 66.276 86.846 66.276 86.846s57.952-79.727 70.708-104.752c13.257-26.001 15.295-62.243-3.996-88.783zm-67.2 103.359a53.315 53.315 0 1 1 53.314-53.315 52.921 52.921 0 0 1-53.317 53.32z"
                transform="translate(-167.748 -237.792)"
              />
            </g>
            <path
              id="Path_702"
              data-name="Path 702"
              class="cls-2"
              d="M274.3 278.005a53.329 53.329 0 0 0-50.255 35.5 45.689 45.689 0 1 1 5.577 46.89 53.311 53.311 0 1 0 44.678-82.39z"
              transform="translate(-178.695 -247.4)"
            />
            <path
              id="Path_703"
              data-name="Path 703"
              class="cls-4"
              d="M274.3 278.005a53.329 53.329 0 0 0-50.255 35.5 45.689 45.689 0 1 1 5.577 46.89 53.311 53.311 0 1 0 44.678-82.39z"
              transform="translate(-178.695 -247.4)"
            />
          </g>
        </g>
      </g>
      <g
        id="Group_1836"
        data-name="Group 1836"
        transform="translate(155.74 614.342)"
      >
        <g
          id="Group_1229-2"
          data-name="Group 1229"
          transform="translate(9.596)"
        >
          <path
            id="Path_286-2"
            data-name="Path 286"
            class="cls-5"
            d="M13.764 7.7a13.706 13.706 0 0 0 .824-1.692 14.291 14.291 0 0 0 .593-1.8 14.717 14.717 0 0 0 .355-1.882 14.944 14.944 0 0 0 .11-1.932L12.066.38q0 .291-.019.581T12 1.54q-.033.288-.081.573t-.119.567v-.024a7.143 7.143 0 0 0-1.048-1.112A6.57 6.57 0 0 0 9.52.72 6.132 6.132 0 0 0 8.177.206a5.893 5.893 0 0 0-1.425-.18h-.319A6.033 6.033 0 0 0 3.84.77a6.889 6.889 0 0 0-2.077 1.76A7.978 7.978 0 0 0 .415 5.057a8.679 8.679 0 0 0-.407 3.031 8.553 8.553 0 0 0 .656 2.972 7.688 7.688 0 0 0 1.55 2.365 6.616 6.616 0 0 0 2.212 1.521 5.927 5.927 0 0 0 3.989.2 6.22 6.22 0 0 0 1.265-.54 6.666 6.666 0 0 0 1.144-.817 7.222 7.222 0 0 0 .987-1.073q.065.283.113.569t.08.576q.032.289.047.581t.013.584l3.576-.023a14.983 14.983 0 0 0-.11-1.932 14.74 14.74 0 0 0-.354-1.881 14.3 14.3 0 0 0-.592-1.8 13.7 13.7 0 0 0-.82-1.69zm-4.9 2.833a3.166 3.166 0 0 1-1.126.724 2.878 2.878 0 0 1-1.239.169 2.946 2.946 0 0 1-1.2-.375 3.34 3.34 0 0 1-1.022-.908 3.742 3.742 0 0 1-.312-.491 3.955 3.955 0 0 1-.237-.539 4.124 4.124 0 0 1-.158-.576 4.231 4.231 0 0 1-.074-.6v-.216a4.224 4.224 0 0 1 .135-1.064A4 4 0 0 1 4.01 5.7a3.637 3.637 0 0 1 .6-.8 3.241 3.241 0 0 1 .79-.58l.036-.02.032-.016.032-.012.032-.015a2.871 2.871 0 0 1 2.492.026 3.27 3.27 0 0 1 1.032.8 3.788 3.788 0 0 1 .71 1.232q.059.166.1.338T9.943 7q.03.175.045.353t.012.356q0 .114-.006.228t-.019.227q-.012.113-.031.225t-.044.222l-.034.037.021.024a4.1 4.1 0 0 1-.161.528 3.941 3.941 0 0 1-.227.492 3.748 3.748 0 0 1-.289.448 3.538 3.538 0 0 1-.346.4z"
            transform="translate(23.826 22.852)"
          />
          <path
            id="Path_699-2"
            data-name="Path 699"
            class="cls-2"
            d="M219.729 250.025a29.435 29.435 0 0 0-24.362-12.372s-22.795 0-29.545 20.405a33.139 33.139 0 0 0 1.082 23.01 42.2 42.2 0 0 0 4.259 7.919c5.885 8.5 24.2 31.716 24.2 31.716h3.982c5.113-7.1 17.986-30.692 21.841-38.256 4.844-9.496 5.588-22.732-1.457-32.422zm-20.561 37.747a19.471 19.471 0 1 1 19.47-19.472 19.471 19.471 0 0 1-19.47 19.472z"
            transform="translate(-164.252 -237.653)"
          />
          <path
            id="Path_700-2"
            data-name="Path 700"
            class="cls-4"
            d="M219.729 250.025a29.435 29.435 0 0 0-24.362-12.372s-22.795 0-29.545 20.405a33.139 33.139 0 0 0 1.082 23.01 42.2 42.2 0 0 0 4.259 7.919c5.885 8.5 24.2 31.716 24.2 31.716h3.982c5.113-7.1 17.986-30.692 21.841-38.256 4.844-9.496 5.588-22.732-1.457-32.422zm-20.561 37.747a19.471 19.471 0 1 1 19.47-19.472 19.471 19.471 0 0 1-19.47 19.472z"
            transform="translate(-164.252 -237.653)"
          />
          <path
            id="Path_701-2"
            data-name="Path 701"
            class="cls-1"
            d="M234.2 250.6a29.436 29.436 0 0 0-24.363-12.372s-22.794 0-29.545 20.405a33.137 33.137 0 0 0 1.082 23.01 42.2 42.2 0 0 0 4.258 7.919c5.885 8.5 24.2 31.716 24.2 31.716S231 292.164 235.66 283.025c4.84-9.498 5.586-22.734-1.46-32.425zm-24.543 37.747a19.471 19.471 0 1 1 19.471-19.471 19.327 19.327 0 0 1-19.471 19.472z"
            transform="translate(-174.715 -238.069)"
          />
        </g>
        <path
          id="Path_702-2"
          data-name="Path 702"
          class="cls-2"
          d="M242.4 278.005a19.476 19.476 0 0 0-18.353 12.965 16.686 16.686 0 1 1 2.037 17.124 19.47 19.47 0 1 0 16.317-30.09z"
          transform="translate(-197.887 -266.828)"
        />
        <path
          id="Path_703-2"
          data-name="Path 703"
          class="cls-4"
          d="M242.4 278.005a19.476 19.476 0 0 0-18.353 12.965 16.686 16.686 0 1 1 2.037 17.124 19.47 19.47 0 1 0 16.317-30.09z"
          transform="translate(-197.887 -266.828)"
        />
      </g>
      <g
        id="Group_1837"
        data-name="Group 1837"
        transform="translate(398.035 634.875)"
      >
        <g
          id="Group_1229-3"
          data-name="Group 1229"
        >
          <path
            id="Path_286-3"
            data-name="Path 286"
            class="cls-5"
            d="M13.764 7.7a13.706 13.706 0 0 0 .824-1.692 14.291 14.291 0 0 0 .593-1.8 14.717 14.717 0 0 0 .355-1.882 14.944 14.944 0 0 0 .11-1.932L12.066.38q0 .291-.019.581T12 1.54q-.033.288-.081.573t-.119.567v-.024a7.143 7.143 0 0 0-1.048-1.112A6.57 6.57 0 0 0 9.52.72 6.132 6.132 0 0 0 8.177.206a5.893 5.893 0 0 0-1.425-.18h-.319A6.033 6.033 0 0 0 3.84.77a6.889 6.889 0 0 0-2.077 1.76A7.978 7.978 0 0 0 .415 5.057a8.679 8.679 0 0 0-.407 3.031 8.553 8.553 0 0 0 .656 2.972 7.688 7.688 0 0 0 1.55 2.365 6.616 6.616 0 0 0 2.212 1.521 5.927 5.927 0 0 0 3.989.2 6.22 6.22 0 0 0 1.265-.54 6.666 6.666 0 0 0 1.144-.817 7.222 7.222 0 0 0 .987-1.073q.065.283.113.569t.08.576q.032.289.047.581t.013.584l3.576-.023a14.983 14.983 0 0 0-.11-1.932 14.74 14.74 0 0 0-.354-1.881 14.3 14.3 0 0 0-.592-1.8 13.7 13.7 0 0 0-.82-1.69zm-4.9 2.833a3.166 3.166 0 0 1-1.126.724 2.878 2.878 0 0 1-1.239.169 2.946 2.946 0 0 1-1.2-.375 3.34 3.34 0 0 1-1.022-.908 3.742 3.742 0 0 1-.312-.491 3.955 3.955 0 0 1-.237-.539 4.124 4.124 0 0 1-.158-.576 4.231 4.231 0 0 1-.074-.6v-.216a4.224 4.224 0 0 1 .135-1.064A4 4 0 0 1 4.01 5.7a3.637 3.637 0 0 1 .6-.8 3.241 3.241 0 0 1 .79-.58l.036-.02.032-.016.032-.012.032-.015a2.871 2.871 0 0 1 2.492.026 3.27 3.27 0 0 1 1.032.8 3.788 3.788 0 0 1 .71 1.232q.059.166.1.338T9.943 7q.03.175.045.353t.012.356q0 .114-.006.228t-.019.227q-.012.113-.031.225t-.044.222l-.034.037.021.024a4.1 4.1 0 0 1-.161.528 3.941 3.941 0 0 1-.227.492 3.748 3.748 0 0 1-.289.448 3.538 3.538 0 0 1-.346.4z"
            transform="translate(23.858 22.852)"
          />
          <path
            id="Path_699-3"
            data-name="Path 699"
            class="cls-2"
            d="M219.729 250.025a29.435 29.435 0 0 0-24.362-12.372s-22.795 0-29.545 20.405a33.139 33.139 0 0 0 1.082 23.01 42.2 42.2 0 0 0 4.259 7.919c5.885 8.5 24.2 31.716 24.2 31.716h3.982c5.113-7.1 17.986-30.692 21.841-38.256 4.844-9.496 5.588-22.732-1.457-32.422zm-20.561 37.747a19.471 19.471 0 1 1 19.47-19.472 19.471 19.471 0 0 1-19.47 19.472z"
            transform="translate(-164.252 -237.653)"
          />
          <path
            id="Path_700-3"
            data-name="Path 700"
            class="cls-4"
            d="M219.729 250.025a29.435 29.435 0 0 0-24.362-12.372s-22.795 0-29.545 20.405a33.139 33.139 0 0 0 1.082 23.01 42.2 42.2 0 0 0 4.259 7.919c5.885 8.5 24.2 31.716 24.2 31.716h3.982c5.113-7.1 17.986-30.692 21.841-38.256 4.844-9.496 5.588-22.732-1.457-32.422zm-20.561 37.747a19.471 19.471 0 1 1 19.47-19.472 19.471 19.471 0 0 1-19.47 19.472z"
            transform="translate(-164.252 -237.653)"
          />
          <path
            id="Path_701-3"
            data-name="Path 701"
            class="cls-1"
            d="M234.2 250.6a29.436 29.436 0 0 0-24.363-12.372s-22.794 0-29.545 20.405a33.137 33.137 0 0 0 1.082 23.01 42.2 42.2 0 0 0 4.258 7.919c5.885 8.5 24.2 31.716 24.2 31.716S231 292.164 235.66 283.025c4.84-9.498 5.586-22.734-1.46-32.425zm-24.543 37.747a19.471 19.471 0 1 1 19.471-19.471 19.327 19.327 0 0 1-19.471 19.472z"
            transform="translate(-174.715 -238.069)"
          />
        </g>
        <path
          id="Path_702-3"
          data-name="Path 702"
          class="cls-2"
          d="M242.4 278.005a19.476 19.476 0 0 0-18.353 12.965 16.686 16.686 0 1 1 2.037 17.124 19.47 19.47 0 1 0 16.317-30.09z"
          transform="translate(-207.483 -266.828)"
        />
        <path
          id="Path_703-3"
          data-name="Path 703"
          class="cls-4"
          d="M242.4 278.005a19.476 19.476 0 0 0-18.353 12.965 16.686 16.686 0 1 1 2.037 17.124 19.47 19.47 0 1 0 16.317-30.09z"
          transform="translate(-207.483 -266.828)"
        />
      </g>
      <ellipse
        id="Ellipse_28"
        data-name="Ellipse 28"
        :style="{fill: shadowColor}"
        cx="20.002"
        cy="2.681"
        rx="20.002"
        ry="2.681"
        transform="translate(405.721 718.938)"
      />
      <ellipse
        id="Ellipse_27"
        data-name="Ellipse 27"
        :style="{fill: shadowColor}"
        cx="74.435"
        cy="7.444"
        rx="74.435"
        ry="7.444"
        transform="matrix(.998 -.07 .07 .998 216.121 716.706)"
      />
      <ellipse
        id="Ellipse_26"
        data-name="Ellipse 26"
        :style="{fill: shadowColor}"
        cx="26.126"
        cy="2.681"
        rx="26.126"
        ry="2.681"
        transform="rotate(11 -3505.254 1148.6)"
      />
    </g>
  </svg>
</template>

<script>
import IconMixin from '@/mixins/icon-mixin'

export default {
  name: 'MultiBranchesIcon',
  mixins: [IconMixin],
  computed: {
    shadowColor() {
      return this.isDark ? '#000000' : '#f4f4f4'
    },
  },
}
</script>

<style lang="scss">
#multi-branches-icon {
  .cls-1 {
    fill: #FF055D
  }

  .cls-2 {
    fill: #ff4f5b
  }

  .cls-3 {
    opacity: .4
  }

  .cls-4 {
    fill: #FF055D
  }

  .cls-5 {
    fill: #FF055D
  }
}
</style>
